import { useEffect, useState } from "react"
import NavElement from "./NavElement"
import { useLocation, useNavigate } from "react-router-dom"

export default function CenterLogoLayout({
  navElements,
  elementSize,
  logoSize,
  brandLogo,
  text,
  elementJustify,
  logoSizeOptions,
}) {
  const navigate = useNavigate()
  const location = useLocation()
  const [leftSideElements, setLeftSideElements] = useState([])
  const [rightSideElements, setRightSideElements] = useState([])

  const handleClickLogo = () => {
    if (!location.pathname.startsWith("/menu")) {
      navigate("/home")
    }
  }

  useEffect(() => {
    if (navElements && navElements?.length === 1) {
      setLeftSideElements(navElements)
      setRightSideElements([])
    } else if (navElements && navElements.length > 0) {
      let leftSize = Math.round(navElements.length / 2)
      let rightSize = navElements.length - leftSize

      let leftElements = navElements.slice(0, leftSize)
      let rightElements = navElements.slice(-rightSize)

      setLeftSideElements(leftElements)
      setRightSideElements(rightElements)
    }
  }, [navElements])

  return (
    <div className="flex w-full bg-[var(--top-bar-bg-color)] border-b-1 border-solid border-[var(--top-bar-border-color)] items-center">
      <div
        className={`flex flex-grow ${
          elementJustify || "justify-around"
        } gap-2 overflow-auto p-2`}
      >
        {leftSideElements.map((navElement) => (
          <NavElement
            key={navElement?.uuid}
            data={navElement}
            text={text}
            size={elementSize}
          />
        ))}
      </div>
      {brandLogo != null && (
        <img
          src={brandLogo}
          alt="logo"
          className={`${
            logoSizeOptions?.[logoSize] || "h-16"
          } shrink-0 object-contain cursor-pointer `}
          onClick={() => handleClickLogo()}
        />
      )}
      <div
        className={`flex flex-grow ${
          elementJustify || "justify-around"
        } gap-2 overflow-auto p-2`}
      >
        {rightSideElements.map((navElement) => (
          <NavElement
            key={navElement.uuid}
            data={navElement}
            text={text}
            size={elementSize}
          />
        ))}
      </div>
    </div>
  )
}
